
import { createBrowserRouter, redirect } from 'react-router';

import { loadNamespace } from './i18n';
import { checkLoginState } from './services/auth.js';

import AppLayout from './layouts/AppLayout.jsx';
import RouteError from './views/RouteError.jsx';

async function authLoader() {
	const authenticated = await checkLoginState();

	if (!authenticated)
		throw redirect('/login');

	return null;
}

async function loadPage(importPage, namespace = null) {
	const [module] = await Promise.all([
		importPage(),
		loadNamespace('common'),
		...(namespace ? [loadNamespace(namespace)] : [])
	]);

	return { Component: module.default };
}

export function createAppRouter() {
	return createBrowserRouter([
		{
			path: '/login',
			lazy: () => loadPage(
				() => import('./views/Login.jsx'),
				'login'
			)
		},
		{
			loader: authLoader,
			Component: AppLayout,
			ErrorBoundary: RouteError,
			children: [
				{
					index: true,
					lazy: () => loadPage(
						() => import('./views/Dashboard.jsx')
					)
				},
				{
					path: 'reservations',
					lazy: () => loadPage(
						() => import('./views/Reservations.jsx'),
						'reservations'
					)
				},
				{
					path: '*',
					lazy: () => loadPage(
						() => import('./views/NotFound.jsx')
					)
				}
			]
		}
	]);
}